import * as Sentry from "@sentry/react";

const dsn = String(process.env.REACT_APP_SENTRY_DSN || "").trim();
export const isSentryEnabled = Boolean(dsn);

export function initSentry() {
  if (!isSentryEnabled) return;

  Sentry.init({
    dsn,
    enabled: isSentryEnabled,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT ||
      process.env.NODE_ENV ||
      "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/api\.matchmixer\.co\.uk/,
    ],
    tracesSampleRate: Number(
      process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.2,
    ),
    // Firebase throws this internally when the Google sign-in popup is closed
    // before completing. It's benign — the user can simply try again.
    ignoreErrors: [/INTERNAL ASSERTION FAILED: Pending promise was never set/],
    sendDefaultPii: false,
  });
}

export function setSentryUser(user) {
  if (!isSentryEnabled) return;

  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.uid,
    email: user.email || undefined,
  });
}

export { Sentry };
